import { render, staticRenderFns } from "./UserProfileDialog.vue?vue&type=template&id=6e26ed41&scoped=true&"
import script from "./UserProfileDialog.vue?vue&type=script&lang=js&"
export * from "./UserProfileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e26ed41",
  null
  
)

export default component.exports